import React, { useEffect } from "react";

export const useTimeout = (callback: () => void, delay: number) => {
  const timerRef = React.useRef<number>(0);
  useEffect(() => {
    timerRef.current = window.setTimeout(callback, delay);
    return () => {
      // Unmount component
      if (timerRef.current) {
        window.clearTimeout(timerRef.current);
      }
    };
  }, [callback, delay]);
};
